import React, { useState, useEffect } from "react";
import { InputField } from "@coverme/forms";

const numberRegex = /[0-9]+/;

function createCurrencyMask(value) {
    if (value == null) {
        return null;
    }

    if (value.replace) {
        var numberValue = value.replace(/[^\\D\\0-9.]/g, '');
        if(numberValue.split(".").length > 2){
            numberValue = numberValue.replace(/\.+$/g, '');
        }
        return numberValue;
    }
    return value;
}

function unmaskValue(value) {
    return value;
}

export const CurrencyInput = ({ changeEvent, value, ...props }) => {
    const [inputValue, changeInputValue] = useState(value ? value : "");

    const onChange = e => {
        changeInputValue(e.currentTarget.value);
    };

    useEffect(() => {
        if (changeEvent) {
            const unmaskedValue = unmaskValue(inputValue);
            changeEvent(unmaskedValue);
        }
    }, [inputValue]);

    const maskedValue = createCurrencyMask(inputValue);

    return <InputField {...props} changeEvent={onChange} value={maskedValue} type="text" placeholder="$0.00" />;
};
